import React from 'react';

const Notification = ({ onClick, text, info = false, buttonText }) => {
    return (
        <div
            className={
                info ? 'notification notification--info' : 'notification'
            }
        >
            <div
                className={
                    info
                        ? 'notification__content notification__content--info'
                        : 'notification__content'
                }
            >
                <div className="notification__content__details">
                    <span
                        className={
                            info
                                ? 'notification__content__details__icon--info'
                                : 'notification__content__details__icon--error'
                        }
                    ></span>
                    <p className="notification__content__details__text">
                        {text}
                    </p>
                </div>
                {buttonText && (
                    <button
                        type="button"
                        className="button notification__content__button"
                        onClick={() => onClick()}
                    >
                        {buttonText}
                    </button>
                )}
            </div>
        </div>
    );
};
export default Notification;
